module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-11-bc96e78b329d4d4caffc4ae44bd120d0.png";